import map from "lodash/map";
import flatten from "lodash/flatten";
import { getChapterEntity } from "selectors/chapter/makeGetChapterEntity";
import { createSelector } from "reselect";

const getQuestionEntities = (state) => state.story.entities.questions;

export default createSelector(
  getChapterEntity,
  getQuestionEntities,
  (chapterEntity, questionEntities) => {
    if (chapterEntity.questions) {
      const topLevelQuestions = chapterEntity.questions;
      const getFlattenedQuestions = (questionId) => {
        const questions = [];
        const entity = questionEntities[questionId];
        questions.push(entity);
        if (entity.questions) {
          entity.questions.forEach((id) => {
            questions.push(...getFlattenedQuestions(id));
          });
        }
        return questions;
      };
      return flatten(map(topLevelQuestions, (id) => getFlattenedQuestions(id)));
    }
    return [];
  },
);
